module.exports = __webpack_public_path__ + "img/concept-llm.e2c1fadb.svg";